import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    introInfo: {
      fontSize: 14,
      color: theme.gray500,
      marginBottom: theme.spacing(12),
      whiteSpace: "pre-line",
    },
    infroTenantBox: {
      padding: theme.spacing(5),
      backgroundColor: theme.orange200,
      borderRadius: "8px",
      color: theme.orange800,
      fontSize: 14,
      fontWeight: 500,
      marginBottom: theme.spacing(6),
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(6),
    },
    icon: {
      width: "24px",
      minWidth: "24px",
      height: "24px",
    },
    wrapper: {
      width: 872,
      margin: "0 auto",
      padding: theme.spacing(6, 0),
    },
    buttonWrapper: {
      marginTop: theme.spacing(12),
      display: "flex",
      justifyContent: "flex-end",
    },
    simulateInfo: {
      fontSize: 14,
      marginTop: theme.spacing(6),
    },
    importTitle: {
      fontSize: 16,
      fontWeight: 400,
      color: theme.gray800,
      margin: theme.spacing(6),
    },
    tableWrapperTitle: {
      fontSize: 14,
      fontWeight: 600,
      color: theme.gray800,
      marginBottom: theme.spacing(8),
    },
    tableWrapper: {
      padding: theme.spacing(8),
      marginBottom: theme.spacing(8),
    },
    backButtonWrapper: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(4),
      width: 872,
      margin: "0 auto",
      padding: theme.spacing(12, 0, 0),
    },
    backTitle: {
      fontSize: 24,
      fontWeight: 400,
      color: theme.gray800,
    },
  }),
);
